import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import PopUp from '../Popup/PopUp';
import BtnSubmit from '../Buttons/BtnSubmit';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';

const termsOfUsePopup = (props) => {
  const createPopUpContent = (props) => {
    {
      const termsLinkList = props.productsInfo.selectedProducts.map(function (item) {
        return (
          <>
            <div className='terms_item'>
              <div className='terms_phone'>{item.existPhone ? item.existPhone : item.newPhone}</div>

              <div className='terms_link_item' onClick={() => prepareUrl(item.programDetailsLink, EpiContext)}>
                <Image src={require('./images/payment-icons-attach.svg')} alt='להורדה' className='terms_icon_attach' />
                עיקרי פרטי התכנית
              </div>

              <div className='terms_link_item' onClick={() => prepareUrl(item.connectionAgreementLink, EpiContext)}>
                <Image src={require('./images/payment-icons-attach.svg')} alt='להורדה' className='terms_icon_attach' />
                הסכם ההתקשרות
              </div>

              {item.selectedVasIdList.length > 0 ? <div>{createVasTermsLinks(item)}</div> : null}
            </div>
          </>
        );
      });
      return termsLinkList;
    }
  };
  const createVasTermsLinks = (item) => {
    {
      const vasLinkList = item.selectedVasList.map(function (vas) {
        return (
          <div className='terms_link_item' onClick={() => prepareUrl(vas.descriptionURL, EpiContext)}>
            <Image src={require('./images/payment-icons-attach.svg')} alt='להורדה' className='terms_icon_attach' />
            {vas.title}
          </div>
        );
      });
      return vasLinkList;
    }
  };
  if (props.productsInfo.selectedProducts.length > 1 || props.productsInfo.selectedProducts[0].selectedVasIdList) {
    return (
      <div className='terms_of_use_popup '>
        <PopUp showPopUp={props.showTermsOfUse} onClose={props.closeTermsOfUse}>
          <>
            <div className='terms-popup-title'>תנאי התוכנית</div>
            <div className='terms-popup'>{createPopUpContent(props)}</div>
          </>
          <BtnSubmit text='חזור לתהליך' onclick={props.closeTermsOfUse} />
        </PopUp>
      </div>
    );
  } else {
    prepareUrl(props.productsInfo.selectedProducts[0].productTermsLink, EpiContext);
  }
};

export default termsOfUsePopup;
